import { Auth0Provider } from "@auth0/auth0-react"
import { ReactNode } from "react"
import { useAuth0Config, useAuth0Service } from "../defaultAuth/hooks"
import { AuthProvider as AuthProviderContext } from "../../contexts/AuthProvider"
import { useParentAuthService } from "../parentAuth/hooks"
import { config } from "../shared/config"

type PropsWithChildren = Readonly<{
  children?: ReactNode | undefined
}>

const Auth0ProviderContext = (props: PropsWithChildren) => {
  const authService = useAuth0Service()

  return <AuthProviderContext authService={authService} {...props} />
}

// Safe to use within an Auth0 Provider
const DefaultAuthProvider = (props: PropsWithChildren) => {
  const { audience, onRedirect, clientId, domain } = useAuth0Config()
  const { origin } = window.location

  return (
    <Auth0Provider
      authorizationParams={{ redirect_uri: origin, audience }}
      onRedirectCallback={onRedirect}
      clientId={clientId}
      domain={domain}
    >
      <Auth0ProviderContext {...props} />
    </Auth0Provider>
  )
}

const ParentAuthProvider = (props: PropsWithChildren) => {
  const authService = useParentAuthService()

  return <AuthProviderContext authService={authService} {...props} />
}

export const AuthProvider = (props: PropsWithChildren) => {
  const { embedded } = config()

  return embedded ? <ParentAuthProvider {...props} /> : <DefaultAuthProvider {...props} />
}
